var map = {
	"./Auth/Login": 2436,
	"./Auth/Login.vue": 2436,
	"./Dashboard/Appointments/Index": 7434,
	"./Dashboard/Appointments/Index.vue": 7434,
	"./Dashboard/Carbs/Index": 7883,
	"./Dashboard/Carbs/Index.vue": 7883,
	"./Dashboard/Cid/Index": 941,
	"./Dashboard/Cid/Index.vue": 941,
	"./Dashboard/Foods/Index": 3047,
	"./Dashboard/Foods/Index.vue": 3047,
	"./Dashboard/Forms/Index": 4136,
	"./Dashboard/Forms/Index.vue": 4136,
	"./Dashboard/Goals/Index": 1372,
	"./Dashboard/Goals/Index.vue": 1372,
	"./Dashboard/Groups/Index": 7942,
	"./Dashboard/Groups/Index.vue": 7942,
	"./Dashboard/HealthTips/Index": 7654,
	"./Dashboard/HealthTips/Index.vue": 7654,
	"./Dashboard/Meta/Index": 2098,
	"./Dashboard/Meta/Index.vue": 2098,
	"./Dashboard/Patients/Detail": 196,
	"./Dashboard/Patients/Detail.vue": 196,
	"./Dashboard/Patients/Index": 1102,
	"./Dashboard/Patients/Index.vue": 1102,
	"./Dashboard/Patients/Tabs/CarePlan": 6951,
	"./Dashboard/Patients/Tabs/CarePlan.vue": 6951,
	"./Dashboard/Patients/Tabs/Certificate": 9183,
	"./Dashboard/Patients/Tabs/Certificate.vue": 9183,
	"./Dashboard/Patients/Tabs/Chat": 3193,
	"./Dashboard/Patients/Tabs/Chat.vue": 3193,
	"./Dashboard/Patients/Tabs/DietForm": 9265,
	"./Dashboard/Patients/Tabs/DietForm.vue": 9265,
	"./Dashboard/Patients/Tabs/Evolution": 8895,
	"./Dashboard/Patients/Tabs/Evolution.vue": 8895,
	"./Dashboard/Patients/Tabs/Forms": 4816,
	"./Dashboard/Patients/Tabs/Forms.vue": 4816,
	"./Dashboard/Patients/Tabs/HealthDiary": 4322,
	"./Dashboard/Patients/Tabs/HealthDiary.vue": 4322,
	"./Dashboard/Patients/Tabs/Milestone": 4119,
	"./Dashboard/Patients/Tabs/Milestone.vue": 4119,
	"./Dashboard/Patients/Tabs/Notifications": 5113,
	"./Dashboard/Patients/Tabs/Notifications.vue": 5113,
	"./Dashboard/Patients/Tabs/OnlineConsultation": 3766,
	"./Dashboard/Patients/Tabs/OnlineConsultation.vue": 3766,
	"./Dashboard/Patients/Tabs/Prescription": 8109,
	"./Dashboard/Patients/Tabs/Prescription.vue": 8109,
	"./Dashboard/Patients/Tabs/Score": 952,
	"./Dashboard/Patients/Tabs/Score.vue": 952,
	"./Dashboard/Patients/Tabs/Timeline": 1586,
	"./Dashboard/Patients/Tabs/Timeline.vue": 1586,
	"./Dashboard/Professionals/Index": 1677,
	"./Dashboard/Professionals/Index.vue": 1677,
	"./Dashboard/Profile": 2637,
	"./Dashboard/Profile.vue": 2637,
	"./Dashboard/Specialties/Index": 3985,
	"./Dashboard/Specialties/Index.vue": 3985,
	"./Dashboard/Terms": 1714,
	"./Dashboard/Terms.vue": 1714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;